/*
 * Copyright 2015-2020 reserved by jufeng.com.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
'use strict';

var $ = require('base');

$.fn.jqueryzoom = function(options) {
	var settings = {
		xzoom : 200,
		yzoom : 200,
		offset : 10,
		position : "right",
		lens : 1,
		preload : 1
	};
	if (options) {
		$.extend(settings, options);
	}

	var noalt = '';
	$(this).hover(
			function() {
				var imageLeft = this.offsetLeft;
				var imageRight = this.offsetRight;
				var imageTop = $(this).get(0).offsetTop;
				var imageWidth = $(this).children('img').get(0).offsetWidth;
				var imageHeight = $(this).children('img').get(0).offsetHeight;
				noalt = $(this).children("img").attr("alt");
				var bigimage = $(this).children("img").attr("jqimg");

				$(this).children("img").attr("alt", '');

				if ($("div.zoomdiv").get().length == 0) {
					$(this).after("<div class='zoomdiv'><img class='bigimg' src='" + bigimage + "'/></div>");
					$(this).append("<div class='jqZoomPup'>&nbsp;</div>");
				}

				if (settings.position == "right") {

					if (imageLeft + imageWidth + settings.offset + settings.xzoom > screen.width) {

						var leftpos = imageLeft - settings.offset - settings.xzoom;

					} else {

						leftpos = imageLeft + imageWidth + settings.offset;
					}
				} else {
					leftpos = imageLeft - settings.xzoom - settings.offset;
					if (leftpos < 0) {

						leftpos = imageLeft + imageWidth + settings.offset;

					}

				}

				$("div.zoomdiv").css({
					top : imageTop,
					left : leftpos
				});

				$("div.zoomdiv").width(settings.xzoom);

				$("div.zoomdiv").height(settings.yzoom);

				$("div.zoomdiv").show();

				if (!settings.lens) {
					$(this).css('cursor', 'crosshair');
				}

				$(document.body).mousemove(
						function(e) {
							var mouse = new MouseEvent(e);
							/* $("div.jqZoomPup").hide(); */
							var bigwidth = $(".bigimg").get(0).offsetWidth;
							var bigheight = $(".bigimg").get(0).offsetHeight;
							var scaley = 'x';
							var scalex = 'y';
							if (isNaN(scalex) | isNaN(scaley)) {
								var scalex = (bigwidth / imageWidth);
								var scaley = (bigheight / imageHeight);
								$("div.jqZoomPup").width((settings.xzoom) / scalex);

								$("div.jqZoomPup").height((settings.yzoom) / scaley);

								if (settings.lens) {
									$("div.jqZoomPup").css('visibility', 'visible');
								}

							}

							xpos = mouse.x - $("div.jqZoomPup").width() / 2 - imageLeft;

							var ypos = mouse.y - $("div.jqZoomPup").height() / 2 - imageTop;

							if (settings.lens) {

								var xpos = (mouse.x - $("div.jqZoomPup").width() / 2 < imageLeft) ? 0 : (mouse.x + $("div.jqZoomPup").width() / 2 > imageWidth + imageLeft) ? (imageWidth
										- $("div.jqZoomPup").width() - 2) : xpos;

								ypos = (mouse.y - $("div.jqZoomPup").height() / 2 < imageTop) ? 0 : (mouse.y + $("div.jqZoomPup").height() / 2 > imageHeight + imageTop) ? (imageHeight
										- $("div.jqZoomPup").height() - 2) : ypos;

							}

							if (settings.lens) {

								$("div.jqZoomPup").css({
									top : ypos,
									left : xpos
								});

							}

							var scrolly = ypos;

							$("div.zoomdiv").get(0).scrollTop = scrolly * scaley;

							var scrollx = xpos;

							$("div.zoomdiv").get(0).scrollLeft = (scrollx) * scalex;

						});
			}, function() {

				$(this).children("img").attr("alt", noalt);
				$(document.body).unbind("mousemove");
				if (settings.lens) {
					$("div.jqZoomPup").remove();
				}
				$("div.zoomdiv").remove();

			});

	var count = 0;

	if (settings.preload) {

		$('body').append("<div style='display:none;' class='jqPreload" + count + "'>loading</div>");

		$(this).each(function() {

			var imagetopreload = $(this).children("img").attr("jqimg");

			var content = $('div.jqPreload' + count + '').html();

			$('div.jqPreload' + count + '').html(content + '<img src=\"' + imagetopreload + '\">');
		});

	}
}

function preview() {
	var img = this;
	$("#preview .jqzoom img").attr("src", $(img).attr("bimg"));
	$("#preview .jqzoom img").attr("jqimg", $(img).attr("bimg"));
}
//图片放大镜效果
$("div.products_img_box div.spec-scroll div.items ul img").on('mousemove', preview);

// 图片放大镜效果
$(".jqzoom").jqueryzoom({
	xzoom : 360,
	yzoom : 360
});
function MouseEvent(e) {
	this.x = e.pageX;
	this.y = e.pageY
}



// WEBPACK FOOTER //
// ./src/main/javascript/vendor/jquery.jqzoom.js